// ProgressBar Component
// Reusable progress bar for XP tracking

import React from 'react';

export default function ProgressBar({
  current,
  max,
  color = '#FF7426',
  bgColor = 'rgba(255, 116, 38, 0.2)',
  height = 8,
  showLabel = false,
  labelPosition = 'top' // 'top', 'bottom', 'inside'
}) {
  const percentage = Math.min(100, Math.max(0, (current / max) * 100));

  return (
    <div style={{ width: '100%' }}>
      {showLabel && labelPosition === 'top' && (
        <div style={{
          fontSize: 12,
          color: '#666',
          marginBottom: 4,
          display: 'flex',
          justifyContent: 'space-between'
        }}>
          <span>{current} XP</span>
          <span>{max} XP</span>
        </div>
      )}

      <div style={{
        width: '100%',
        height,
        backgroundColor: bgColor,
        borderRadius: height / 2,
        overflow: 'hidden',
        position: 'relative'
      }}>
        <div style={{
          width: `${percentage}%`,
          height: '100%',
          backgroundColor: color,
          borderRadius: height / 2,
          transition: 'width 0.5s ease',
          position: 'relative'
        }}>
          {showLabel && labelPosition === 'inside' && percentage > 20 && (
            <span style={{
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: 10,
              color: '#fff',
              fontWeight: 700
            }}>
              {Math.round(percentage)}%
            </span>
          )}
        </div>
      </div>

      {showLabel && labelPosition === 'bottom' && (
        <div style={{
          fontSize: 12,
          color: '#666',
          marginTop: 4,
          textAlign: 'center'
        }}>
          {current} / {max} XP ({Math.round(percentage)}%)
        </div>
      )}
    </div>
  );
}
